module.exports = __webpack_public_path__ + "img/print-icon.8e48e54f.png";